// Others
import { IBaseOption } from '~/utils/interface/common';

export const mockDataCustomerTags: IBaseOption[] = [
  { label: 'Residential New', value: 'RESIDENTIAL_NEW' },
  { label: 'Residential Repeat', value: 'RESIDENTIAL_REPEAT' },
  { label: 'Commercial New', value: 'COMMERCIAL_NEW' },
  { label: 'Commercial Repeat', value: 'COMMERCIAL_REPEAT' },
];
